export interface Specialization {
  name: string;
  general_category: 'Building' | 'Crafting' | 'Gathering' | 'Management';
  specific_category: string;
  all_levels: number[];
  description: string;
  source_sections: string;
}

export interface PlayerChoice {
  playerId: string;
  level: number;
  availableSpecs: string[]; // 4 specs offered to the player
  chosenSpec?: string; // The spec they actually chose
}

export interface Player {
  id: string;
  name: string;
  choices: { [level: number]: PlayerChoice };
}

export interface AppState {
  players: Player[];
  specializations: Specialization[];
}

export const CATEGORY_COLORS = {
  Building: '#3B82F6', // Blue
  Crafting: '#10B981', // Green  
  Gathering: '#F59E0B', // Amber
  Management: '#8B5CF6', // Purple
} as const;

export const LEVELS = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50] as const;